var _circle, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBadgeBlog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "url(#paint0_linear_3963_6630)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.30859,
    y: 4.30859,
    width: 7.38462,
    height: 7.38462,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3963_6630",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3963_6630",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06E5E5",
    stopOpacity: 0.718854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A59DB"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3963_6630",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAACRUlEQVR4nO3cPW7UQByG8fcPhCbhCog6XINEQpFyBwQUXABaKroUSNDlGggpt6Chooi4AqLKx1CsCxSxO2OvZ16z8/xqOx752bHGsTQSAAAAAAAAehFjT0gpPZX0StKRpCeS9uce1H/mt6RLSReSziPi+5iTiwOklB5KOpP0RtL9MRfpyLWkT5LeRsRVyQlFAYab/0XSs+lj68pXSacRcZ078F7hHzwTN3+M55I+lByYnQHDM/+beOyMdSXpMCJ+bDqoZAa8Fjd/ij1JL3IHlQQ42n4s3creu5IAj2cYSK+y964kwMEMA+nVo9wBpasgVEIAMwKYPWh9wYgY/f+nllJKqeX1mAFmBDAjQF3Zxy0BzAhgRgAzApg1fw9ovc5eOmaAGQHqYhm6dAQwI4AZAcwIYMb3gDv4HrBbWIYuHQHMCGBGADMCmBHAjO8BdbEMXToCmBHAjABmBDAjgBkB6souQ3f+e8DS3zuYAWYEMCOAGQHMCGBGADMC1LW894Clr8tbYwaYEcCMAGYlAX5VH0XHSgL8rD6K3TXLR/mLGQaCNUoCnEu6qT2QXmUDDHshf24wli6Vbl28p9XWxWxhOc5NRGx82S1ahg4bUZ9I+qjVBtUok/2BT9m+/lDSS0nHWm1fz7aW691GBLsObyOl9C5Nx9NiDltEYPU4l4kRCDCnCREIMLeREQhQw4gIBKilMAIBaiqIQIDaMhFu3ePrwoYIBGhlTQQCtPSPCARo7U4EAjj8FYEALkMEAjillN67xwAAWK4/qzheqxUOOm8AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBadgeBlog);
export default __webpack_public_path__ + "static/media/ic_badge_blog.04e0794bd0f286d5de0c8d618423aef2.svg";
export { ForwardRef as ReactComponent };